import React from 'react'
import { Tooltip, TooltipProps } from 'react-leaflet'
import styled from 'styled-components'

function TooltipComponent({ ...props }: TooltipProps) {
  return <StyleTooltip {...props}>{props.children}</StyleTooltip>
}

const StyleTooltip = styled(Tooltip)`
  background: #fff1b8 !important;
  border: 1px solid transparent !important;
  box-shadow: none !important;

  &.leaflet-tooltip-top::before {
    border-top-color: #fff1b8 !important;
  }
`

export default React.memo(TooltipComponent)
